import React from 'react'
import { apiGet, apiPost, apiDelete, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

const OtherTask = () => {
  const { t_ } = useSmartTranslation()

  const columns = [{
    name: t_('Code'),
    field: 'code',
    charLimit: 60,
    mandatory: true,
    unique: true,
    readOnly: true
  },
  {
    name: t_('Name'),
    field: 'name',
    charLimit: 80,
    mandatory: true,
    unique: true,
    // Seeded tasks are translated by the table (P17): their name cannot be changed, like every other seeded table.
    readOnly: (row) => row.systemDefault === true
  },
  {
    name: t_('Description'),
    field: 'description',
    charLimit: 200
  },
  {
    name: t_('Stand By'),
    field: 'standBy',
    type: 'boolean'
  },
  {
    name: t_('Productive Task'),
    field: 'productiveTask',
    type: 'boolean'
  }
  ]

  const actions = {
    edit: {
      fetchFunction: (row) => {
        return apiPut('otherTask', row)
      }
    },
    create: {
      fetchFunction: (row) => {
        return apiPost('otherTask', row)
      }
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('otherTask/' + rows[0].id, rows)
        } else {
          return apiDelete('otherTaskMultiDelete', rows)
        }
      },
      visibilityButton: (qualityTypes) => !qualityTypes.systemDefault
    }
  }

  const fetchFunction = async (pagination) => {
    const otherTasks = await apiGet('otherTasks', pagination)
    return otherTasks
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='otherTask'
      columns={columns}
      title={t_('Other tasks')}
      dataFetch={fetchFunction}
      actions={actions}
      multipleSelection
      multipleOptions
      pageable
      safeDeleteShowProperty='name'
    />
  )
}

export default OtherTask
